export const theme = {
  colors: {
    // Couleurs principales - Charte Patrick Sanchez
    primary: {
      50: '#fef2f3',
      100: '#fde6e8',
      200: '#fbd0d5',
      300: '#f7aab2',
      400: '#f17a89',
      500: '#d13d4b',  // Rouge bordeaux principal
      600: '#b83541',
      700: '#9a2d37',
      800: '#7c242d',
      900: '#5e1c23',
    },

    // Couleurs secondaires - Tons de gris pour dark theme
    secondary: {
      50: '#f5f5f5',
      100: '#e5e5e5',
      200: '#cccccc',  // Gris clair texte
      300: '#b3b3b3',
      400: '#999999',
      500: '#888888',  // Gris moyen texte
      600: '#666666',
      700: '#4d4d4d',
      800: '#333333',  // Gris foncé séparateurs
      900: '#1a1a1a',
    },

    // Couleur d'accent (identique au primary)
    accent: {
      500: '#d13d4b',  // Rouge bordeaux
    },

    // Couleurs sémantiques
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#d13d4b',

    // Arrière-plans - Dark theme
    background: '#000000',  // Noir total
    surface: '#111111',     // Noir légèrement plus clair
    card: '#1a1a1a',        // Carte/sections

    // Texte
    text: {
      primary: '#ffffff',    // Blanc
      secondary: '#cccccc',  // Gris clair
      muted: '#888888',      // Gris moyen
      inverse: '#000000',
    },
  },

  typography: {
    fontFamily: {
      sans: 'Tahoma, Geneva, system-ui, -apple-system, sans-serif',
      serif: '"Merriweather", Georgia, serif',
      mono: '"JetBrains Mono", Monaco, monospace',
    },

    fontSize: {
      xs: ['0.75rem', { lineHeight: '1rem' }],
      sm: ['0.875rem', { lineHeight: '1.25rem' }],
      base: ['1rem', { lineHeight: '1.5rem' }],
      lg: ['1.125rem', { lineHeight: '1.75rem' }],
      xl: ['1.25rem', { lineHeight: '1.75rem' }],
      '2xl': ['1.5rem', { lineHeight: '2rem' }],
      '3xl': ['1.875rem', { lineHeight: '2.25rem' }],
      '4xl': ['2.25rem', { lineHeight: '2.5rem' }],
      '5xl': ['3rem', { lineHeight: '1' }],
    },

    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
  },

  spacing: {
    xs: '0.5rem',    // 8px
    sm: '1rem',      // 16px
    md: '1.5rem',    // 24px
    lg: '2rem',      // 32px
    xl: '3rem',      // 48px
    '2xl': '4rem',   // 64px
    '3xl': '6rem',   // 96px
  },

  borderRadius: {
    none: '0',
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    full: '9999px',
  },

  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1)',
  },

  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },

  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '500ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
};
